import dataEn from "../data/data.en.json";
import dataEs from "../data/data.es.json";
import dataNl from "../data/data.nl.json";
import dataFr from "../data/data.fr.json";
import dataDe from "../data/data.de.json";
import portalEn from "./portal.en.json";
import portalEs from "./portal.es.json";
import portalNl from "./portal.nl.json";
import portalFr from "./portal.fr.json";
import portalDe from "./portal.de.json";

export const LANGUAGE_STORAGE_KEY = "fastlex-language";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "EN", name: "English" },
  { code: "nl", label: "NL", name: "Nederlands" },
  { code: "es", label: "ES", name: "Español" },
  { code: "fr", label: "FR", name: "Français" },
  { code: "de", label: "DE", name: "Deutsch" },
];

export const DEFAULT_LANGUAGE = "en";

const dataByLanguage = {
  en: dataEn,
  nl: dataNl,
  es: dataEs,
  fr: dataFr,
  de: dataDe,
};

const portalByLanguage = {
  en: portalEn,
  nl: portalNl,
  es: portalEs,
  fr: portalFr,
  de: portalDe,
};

export const getLanguageData = (language) =>
  dataByLanguage[language] ?? dataByLanguage[DEFAULT_LANGUAGE];

export const getPortalCopy = (language) =>
  portalByLanguage[language] ?? portalByLanguage[DEFAULT_LANGUAGE];

export const isSupportedLanguage = (language) =>
  Object.prototype.hasOwnProperty.call(dataByLanguage, language);

/** Replace `{key}` placeholders in a translation string. */
export const t = (template, vars = {}) => {
  if (!template) return "";
  return String(template).replace(/\{(\w+)\}/g, (_, key) =>
    vars[key] != null ? String(vars[key]) : `{${key}}`
  );
};
